export default {
  order: 12,
  layerGroupId: 'GROUP_LCD',
  dataLayer: {
    id: 'INPE_AMAZON_PRODES',
    order: 12,
    type: 'remoteDataLayer',
    uuid: 'ac72942c-d508-4929-b5fb-104e5c948d09',
    groupId: 'GROUP_LCD',
  },
  layer: {
    sublabel: {
      ka: 'annual, 6.25ha, Legal Amazon / Cerrado, INPE',
      zh: '每年, 6.25ha, Legal Amazon / Cerrado, INPE',
      id: 'tahunan, 6.25ha, Legal Amazon / Cerrado, INPE',
      pt: 'წლიური, 6.25ha, Legal Amazon / Cerrado, INPE',
      es: 'anual, 6.25ha, Legal Amazon / Cerrado, INPE',
      fr: 'annuelle, 6.25ha, Legal Amazon / Cerrado, INPE',
      en: 'annual, 6.25ha, Legal Amazon / Cerrado, INPE',
    },
    label: {
      ka: 'PRODES Amazon Biome',
      zh: 'PRODES Amazon Biome',
      id: 'PRODES Amazon Biome',
      pt: 'PRODES Amazon Biome',
      es: 'PRODES Amazon Biome',
      fr: 'PRODES Amazon Biome',
      en: 'PRODES Amazon Biome',
    },
    technicalName: 'inpe_amazon_prodes',
    url: 'https://tiles.globalforestwatch.org/inpe_amazon_prodes/latest/default/root.json',
    type: 'Vector.Layer',
    id: 'INPE_AMAZON_PRODES',
    metadata: {
      metadata: null,
      legendConfig: {
        items: [
          {
            name: {
              en: 'PRODES Deforestation',
              fr: 'PRODES Déforestation',
              es: 'PRODES Deforestación',
              pt: 'PRODES Desmatamento',
              id: 'PRODES Deforestasi',
              zh: 'PRODES 滥伐',
              ka: 'PRODES ტყის გაჩეხვის',
            },
            color: '#C92A6D',
            outlineColor: '#C92A6D',
          },
        ],
        source: '',
        notes: [''],
        name: {
          en: 'PRODES Deforestation',
          fr: 'PRODES Déforestation',
          es: 'PRODES Deforestación',
          pt: 'PRODES Desmatamento',
          id: 'PRODES Deforestasi',
          zh: 'PRODES 滥伐',
          ka: 'PRODES ტყის გაჩეხვის',
        },
        type: 'basic',
      },
      interactionConfig: {},
    },
    style: 'https://tiles.globalforestwatch.org/inpe_amazon_prodes/latest/default/root.json',
  },
  isMetadataError: false,
  isError: false,
};
